import { bookmarkStore } from './stores'

export function init() {
  const posts = window.localStorage.getItem('bookmarks')
  if (posts) {
    JSON.parse(posts).forEach(bookmarkStore.add)
  }
}

export function add(post) {
  bookmarkStore.add(post)
  store()
}

export function del(post) {
  const index = getIndex(post)
  if (0 <= index) {
    bookmarkStore.del(index)
    store()
  }
}

// getIndex 는 url (글 자연 키) 로 북마크 여부를 판단한다.
// id (auto PK) 는 DB 재적재로 흔들려 부적합 — export/import·화면 토글 모두 url 로 통일한다.
export function getIndex(post) {
  return bookmarkStore.posts.findIndex(({ url }) => url === post.url)
}

export function has(post) {
  return 0 <= getIndex(post)
}

export function reverse() {
  console.log('all:', bookmarkStore.posts)
  return bookmarkStore.posts.reverse()
}

export function count() {
  return bookmarkStore.posts.length
}

// list 는 최신 글이 위로 오도록 뒤집은 표시용 목록을 반환한다 (원본 posts 비파괴 — in-place 인 reverse 와 다름).
export function list() {
  return bookmarkStore.posts.slice().reverse()
}

// exportText 는 다시보기 목록을 다른 기기로 옮길 수 있게 JSON 문자열로 직렬화한다.
// 화면 렌더에 쓰는 3필드만 담는다 — 불안정한 id·표시에 안 쓰는 hit·post_time 은 다른 기기로 실어 나르지 않는다.
export function exportText() {
  const slim = bookmarkStore.posts.map(({ publisher, url, subject }) => ({ publisher, url, subject }))
  return JSON.stringify(slim)
}

// importText 는 내보낸 JSON 을 파싱해 기존 목록과 병합한다.
// 중복 판단은 url (글 자연 키) 기준 — DB 재적재로 id (auto PK) 가 바뀌어도 흔들리지 않는다.
// 파싱 실패는 조용히 삼키지 않고 에러로 표면화. 추가된 개수를 반환한다.
export function importText(text) {
  let parsed
  try {
    parsed = JSON.parse(text)
  } catch (e) {
    throw new Error('JSON 형식이 아닙니다')
  }
  if (!Array.isArray(parsed)) {
    throw new Error('다시보기 목록 (배열) 형식이 아닙니다')
  }
  const existingUrls = new Set(bookmarkStore.posts.map(p => p.url))
  let added = 0
  parsed.forEach(post => {
    if (!post || !post.url || existingUrls.has(post.url)) {
      return
    }
    bookmarkStore.add(post)
    existingUrls.add(post.url)
    added++
  })
  if (0 < added) {
    store()
  }
  return added
}

function store() {
  window.localStorage.setItem('bookmarks', JSON.stringify(bookmarkStore.posts))
}

init()